const calculableMonetaryIncentives = new Set(["REBATE", "TAX CREDIT", "TAX EXEMPTION"]);

export default calculableMonetaryIncentives;